<template>
  <div class='ClientReg'>
    <div class="title">
      Informações
    </div>
    <div class="login" v-if="!Object.keys(Profile).length">
      Já é cliente?
      <span
      v-if="Empresa.modelo === 'Modelo 01'"
      @click="SetModal01({ component: 'EnbLogin01', active: true })"
      class="link-login">
        Clique aqui para entrar
      </span>
      <span
      v-if="Empresa.modelo === 'Modelo 02'"
      @click="SetModal01({ component: 'EnbLogin02', active: true, barText: 'login' })"
      class="link-login">
        Clique aqui para entrar
      </span>
    </div>
    <div>
      <input-reg
      :value="SelectedClientEdit.usuario.usuario"
      @update:model-value="newValue => ChangeClientEdit({ usuario: { usuario: newValue } })"
      text="Usuário(Mínimo 4 caracteres)"
      :cont="{ width: '100%' }"
      :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '94%', borderRadius: '5px' }"
      :disabled="Object.keys(Profile).length"
      :error="ClientValidate.usuario.$invalid"
      :errorMsg="ClientValidate.usuario.has.$invalid ? ClientValidate.usuario.has.$message : ''"
      />
    </div>
    <div>
      <input-reg
      :value="SelectedClientEdit.usuario.nome"
      @update:model-value="newValue => ChangeClientEdit({ usuario: { nome: newValue } })"
      text="Primeiro nome"
      :cont="{ width: '100%' }"
      :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '94%', borderRadius: '5px' }"
      :disabled="Object.keys(Profile).length"
      :error="ClientValidate.nome.$invalid"
      />
    </div>
    <div>
      <input-reg
      :value="SelectedClientEdit.usuario.sobrenome"
      @update:model-value="newValue => ChangeClientEdit({ usuario: { sobrenome: newValue } })"
      text="Sobrenome"
      :cont="{ width: '100%' }"
      :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '94%', borderRadius: '5px' }"
      :disabled="Object.keys(Profile).length"
      :error="ClientValidate.sobrenome.$invalid"
      />
    </div>
    <div style="display: flex; justify-content: center">
      <input-reg
      :value="SelectedClientEdit.endereco.cpf"
      @update:model-value="newValue => ChangeClientEdit({ endereco: { cpf: newValue } })"
      text="CPF"
      :cont="{ width: '48.5%' }"
      :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
      :input="{ fontSize: '20px', padding: '2.5%', width: '95%', borderRadius: '5px' }"
      :Mask="['###.###.###-##']"
      :disabled="Object.keys(Profile).length"
      :error="ClientValidate.cpf.$invalid"
      />
      <input-reg
      :value="SelectedClientEdit.endereco.cep"
      @update:model-value="newValue => getEndereco(newValue)"
      text="CEP"
      :cont="{ width: '47%', paddingLeft: '2%' }"
      :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
      :input="{ fontSize: '20px', padding: '2.5%', width: '95%', borderRadius: '5px' }"
      :Mask="['#####-###']"
      :disabled="Object.keys(Profile).length"
      :error="ClientValidate.cep.$invalid"
      />
    </div>
    <div>
      <input-reg
      :value="SelectedClientEdit.endereco.endereco"
      @update:model-value="newValue => ChangeClientEdit({ endereco: { endereco: newValue } })"
      text="Endereço"
      :cont="{ width: '100%' }"
      :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '94%', borderRadius: '5px' }"
      disabled
      :error="ClientValidate.endereco.$invalid"
      />
    </div>
    <div style="display: flex; justify-content: center">
      <input-reg
      :value="SelectedClientEdit.endereco.bairro"
      @update:model-value="newValue => ChangeClientEdit({ endereco: { bairro: newValue } })"
      text="Bairro"
      :cont="{ width: '48.5%' }"
      :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
      :input="{ fontSize: '20px', padding: '2.5%', width: '95%', borderRadius: '5px' }"
      disabled
      :error="ClientValidate.bairro.$invalid"
      />
      <input-reg
      :value="SelectedClientEdit.endereco.numero"
      @update:model-value="newValue => ChangeClientEdit({ endereco: { numero: newValue } })"
      text="Número"
      :cont="{ width: '47%', paddingLeft: '2%' }"
      :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
      :input="{ fontSize: '20px', padding: '2.5%', width: '95%', borderRadius: '5px' }"
      :Mask="['########']"
      :disabled="Object.keys(Profile).length"
      :error="ClientValidate.numero.$invalid"
      />
    </div>
    <div>
      <input-reg
      :value="SelectedClientEdit.endereco.cidade"
      @update:model-value="newValue => ChangeClientEdit({ endereco: { cidade: newValue } })"
      text="Cidade"
      :cont="{ width: '100%' }"
      :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '94%', borderRadius: '5px' }"
      disabled
      :error="ClientValidate.cidade.$invalid"
      />
    </div>
    <div style="display: flex; justify-content: center">
      <input-reg
      :value="SelectedClientEdit.endereco.uf"
      @update:model-value="newValue => ChangeClientEdit({ endereco: { uf: newValue } })"
      text="Estado(UF)"
      :cont="{ width: '48.5%' }"
      :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
      :input="{ fontSize: '20px', padding: '2.5%', width: '95%', borderRadius: '5px' }"
      :Mask="['AA']"
      disabled
      :error="ClientValidate.uf.$invalid"
      />
      <input-reg
      :value="SelectedClientEdit.endereco.celular"
      @update:model-value="newValue => ChangeClientEdit({ endereco: { celular: newValue } })"
      text="Celular"
      :cont="{ width: '47%', paddingLeft: '2%' }"
      :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
      :input="{ fontSize: '20px', padding: '2.5%', width: '95%', borderRadius: '5px' }"
      :Mask="['(##) #####-####', '(##) ####-####']"
      :disabled="Object.keys(Profile).length"
      :error="ClientValidate.celular.$invalid"
      />
    </div>
    <div>
      <input-reg
      :value="SelectedClientEdit.usuario.email"
      @update:model-value="newValue => ChangeClientEdit({ usuario: { email: newValue } })"
      text="Endereço de email"
      :cont="{ width: '100%' }"
      :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '94%', borderRadius: '5px' }"
      :disabled="Object.keys(Profile).length"
      :error="ClientValidate.email.$invalid"
      :errorMsg="ClientValidate.email.has.$invalid ? ClientValidate.email.has.$message : ''"
      />
    </div>
    <div style="display: flex; justify-content: center">
      <input-reg
      :value="SelectedClientEdit.usuario.senha"
      @update:model-value="newValue => ChangeClientEdit({ usuario: { senha: newValue } })"
      text="Senha(Mínimo 6 caracteres)"
      type="password"
      :cont="{ width: '48.5%' }"
      :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
      :input="{ fontSize: '20px', padding: '2.5%', width: '95%', borderRadius: '5px' }"
      :disabled="Object.keys(Profile).length"
      :error="ClientValidate.senha.$invalid"
      v-if="!Object.keys(Profile).length"
      />
      <input-reg
      :value="SelectedClientEdit.usuario.csenha"
      @update:model-value="newValue => ChangeClientEdit({ usuario: { csenha: newValue } })"
      text="Confirmar senha"
      type="password"
      :cont="{ width: '47%', paddingLeft: '2%' }"
      :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
      :input="{ fontSize: '20px', padding: '2.5%', width: '95%', borderRadius: '5px' }"
      :disabled="Object.keys(Profile).length"
      :error="ClientValidate.csenha.$invalid"
      v-if="!Object.keys(Profile).length"
      />
    </div>
    <div>
      <input-text
      text="Informações adicionais"
      :value="NotasPedido"
      @update:modelValue="newValue => SetNotasPedido(newValue)"
      :label="{ textAlign: 'left', marginLeft: '10px', marginTop: '5px' }"
      :input="{ padding: '2%', fontSize: '16px', width: '93%', borderRadius: '5px' }"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InputReg from '@/components/EnbPainel/Produtos/Register/InputReg'
import InputText from '@/components/EnbPainel/Produtos/Register/InputText'
export default {
  name: 'ClientReg',
  components: { InputReg, InputText },
  computed: {
    ...mapGetters(['SelectedClientEdit', 'Profile', 'ClientValidate', 'Empresa', 'CheckoutTotal01', 'Frete', 'NotasPedido'])
  },
  methods: {
    ...mapActions(['SetModal01', 'ChangeClientEdit', 'getApiCep', 'GetFreteVerify', 'SetNotasPedido']),
    getEndereco (cep) {
      if (cep.length === 9) {
        this.getApiCep(cep.replace('-', ''))
          .then((data) => {
            this.ChangeClientEdit({
              endereco: {
                bairro: data.bairro,
                endereco: data.logradouro,
                cidade: data.localidade,
                uf: data.uf
              }
            })
            //Verificando o frete
            if(this.Frete.tipo === 'Tabela Bairro' || this.Frete.tipo === 'Por KM') {
              this.GetFreteVerify({
                tipo: this.Frete.tipo,
                bairro: data.bairro,
                cep: cep.replace('-', ''),
                total: this.CheckoutTotal01
              })
            }
          })
      }
      this.ChangeClientEdit({ endereco: { cep: cep } })
    }
  },
  data () {
    return {
      vUsuario: false,
      vEmail: false
    }
  }
}
</script>

<style scoped>
.ClientReg {
  padding: 3%;
}

.title {
  font-size: 22px;
}

.login {
  width: 93%;
  border: thin solid #007cba;
  border-radius: 5px;
  padding: 2%;
  margin: auto;
  margin-top: 2%;
}

.link-login {
  cursor: pointer;
  color: #007cba;
}
</style>
